<template>
  <div class="comment-count-parts" :class="`comment-count-parts--${commentCountStatus}`">
    <svg
      v-if="remainingCommentCount > -10"
      class="comment-count-parts__indicator"
      width="24"
      height="24"
      fill="none"
    >
      <g transform="rotate(-90, 12, 12)">
        <circle
          class="comment-count-parts__indicator-bar"
          :style="indicatorBarStyle"
          cx="12"
          cy="12"
          :r="circleRadius"
          stroke-width="2"
        ></circle>
        <circle
          class="comment-count-parts__indicator-bg"
          cx="12"
          cy="12"
          :r="circleRadius"
          stroke-width="2"
        ></circle>
      </g>
    </svg>
    <p v-if="remainingCommentCount <= 20" class="comment-count-parts__indicator-number">
      {{ remainingCommentCount }}
    </p>
  </div>
</template>

<script lang="ts">
import { defineComponent, computed } from '@vue/composition-api'
import Const from '@/util/Const'

export default defineComponent({
  name: 'CommentCountParts',
  props: {
    comment: {
      type: String,
      default: '',
    },
    commentLength: {
      type: Number,
      default: 0,
    },
  },
  setup(props) {
    const remainingCommentCount = computed(
      () => Const.MAX_HIGHLIGHT_COMMENT_LENGTH - props.commentLength,
    )
    const commentRatio = computed(() => {
      if (props.commentLength === 0) {
        return 0
      }
      return props.commentLength / Const.MAX_HIGHLIGHT_COMMENT_LENGTH
    })

    const commentCountStatus = computed(() => {
      if (remainingCommentCount.value <= -10) {
        // 残り文字数が-10以上になったら円表示を非表示にする
        return 'excess'
      }
      if (remainingCommentCount.value <= 0) {
        // 残りの文字数がなくなったら赤く表示する
        return 'over'
      }
      if (remainingCommentCount.value <= 20) {
        // 残り20文字以下は黄色の警告表示する
        return 'alert'
      }
      return 'normal'
    })

    const circleRadius = computed(() => {
      if (commentCountStatus.value === 'normal') {
        return 9
      }
      return 11
    })

    const indicatorBarStyle = computed(() => {
      if (remainingCommentCount.value <= 0) {
        return {}
      }
      // 円周
      const circumference = circleRadius.value * 2 * 3.14
      return {
        'stroke-dasharray': `${circumference}px ${circumference}px`,
        'stroke-dashoffset': `${(1 - commentRatio.value) * circumference}`,
      }
    })

    return {
      commentCountStatus,
      remainingCommentCount,
      circleRadius,
      indicatorBarStyle,
    }
  },
})
</script>

<style scoped lang="scss">
.comment-count-parts {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;

  &__indicator {
    &-bar {
      stroke: #00dba6;
      stroke-linecap: round;

      .comment-count-parts--alert & {
        stroke: #f2c94c;
      }

      .comment-count-parts--over & {
        stroke: #ff4949;
      }
    }

    &-bg {
      position: absolute;
      top: 0;
      left: 0;
      stroke: rgba(#fff, 0.2);
      stroke-linecap: round;
    }

    &-number {
      position: absolute;
      top: 50%;
      right: 50%;
      font-size: 12px;
      color: #fff;
      transform: translate(50%, -50%);

      .comment-count-parts--over & {
        color: #ff4949;
      }

      .comment-count-parts--excess & {
        right: 5px;
        color: #ff4949;
        transform: translateY(-50%);
      }
    }
  }
}
</style>
